(function ($) {

    'use strict';

    $.fn.addAlert = function (type, message, items, dismissable) {

        var close = '';

        if (items) {
            var itemsArray = [];
            $.each(items, function (index, value) {
                index = index.replace(/_/g, ' ');
                // var error = index.charAt(0).toUpperCase() + index.substring(1) + ' ' + value;
                if (value == 'The g-recaptcha-response field is required.') {
                    value = 'reCAPTCHA needs to confirmed.';
                }
                var error = value;
                if (index == 'base') {
                    error = value;
                }
                itemsArray.push('<li>' + error + '</li>');
            });
            items = itemsArray.join('');
            items = '<p style="font-size: 1.4em; font-weight: bold;">' + message + '</p>' + '<ul class="mb-0">' + items + '</ul>';
            message = items;
        }

        if (dismissable) {
            close = '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>';
        }

        this.append('<div class="alert alert-' + type + '">' + close + message + '</div>');

    };

})(jQuery);



// WEBPACK FOOTER //
// ./scripts/icaal-contact-form-v2-addalert.js